module.exports = __webpack_public_path__ + "static/media/oleg_normal_right.c3e7657d.png";